import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.ROOT_API, //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});
export const HTTPGUZZLE = axios.create({

    baseURL: "https://www.velocitytruckcentres.com.au", //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});

/* Interceptors logic to add the static location */
HTTPGUZZLE.interceptors.response.use(function (response) {

  if(response.data.locations && response.data.locations.length > 0) {
    var objFlagstaff330 = {
          "name": "Corporate Warranty",
          "id": 1000,
          "slug": "corporate-warranty",
          "address": "",
          "position": {
            "lat": 0.00,
            "lng": -0.00
          },
          "content": "<div class=\"map-window-container\"><div class=\"map-window-left\"><div class=\"map-window-left-custom-container\"><div class=\"map-window-left-custom\"><div class=\"map-window-details-block\"><span>Broome, WA</span><strong>4 De Castilla St, Broome WA 6725, Australia</strong></div></div></div><div class=\"map-window-right\"><div class=\"map-btn phone-btn\"><a href=\"tel:08 9192 1330\"class=\"hvr-sweep-to-right\"><p class=\"sp-mr\">CALL 08 9192 1330</p><img src=\"https://www.velocitytruckcenters.com/themes/vtc/assets/images/map-phone.png\" alt=\"Phone\"></a></div><div class=\"map-btn direction-btn\"><a href= class=\"hvr-sweep-to-right\" target=\"_blank\"><p>DIRECTIONS TO THIS DEALERSHIP</p><img src=\"https://www.velocitytruckcenters.com/themes/vtc/assets/images/map-direction.png\" alt=\"Phone\"></a></div></div></div></div>",
          "is_buswest": false,
        };
        response.data.locations.push(objFlagstaff330);
    }
  return response;

});


// WEBPACK FOOTER //
// ./src/http-common.js